import { render, staticRenderFns } from "./ProgramacaoTransportadora.vue?vue&type=template&id=502050c0"
import script from "./ProgramacaoTransportadora.vue?vue&type=script&lang=js"
export * from "./ProgramacaoTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports